import { cva } from 'class-variance-authority';

export const buttonVariants = cva(
  `
    inline-flex items-center justify-center gap-2 rounded-full font-sans
    text-[13px] leading-[20px] font-normal whitespace-nowrap
    ring-offset-background transition-colors cursor-pointer
    focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
    focus-visible:outline-none
    disabled:pointer-events-none disabled:opacity-50
    [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0
  `,
  {
    variants: {
      variant: {
        default: `
            bg-neutral-600 text-[#FCFEFF] shadow
            hover:bg-[#444]
            active:opacity-50
          `,
        destructive: `
            bg-semantic-red-500 text-neutral-light-50 shadow-sm
            hover:bg-semantic-red-100
          `,
        outline: `
            border border-neutral-600 bg-transparent text-neutral-600 border-[#D1D5DB]
            hover:bg-neutral-600 hover:text-[#FCFEFF]
          `,
        secondary: `
            bg-secondary text-secondary-foreground shadow-sm
            hover:bg-secondary/80
          `,
        ghost: `
          hover:bg-neutral-600]/10
          text-neutral-600
        `,
        link: `
          text-neutral-600 underline-offset-4
          hover:underline
        `,
      },
      size: {
        default: 'h-8 px-3.5 py-1.5',
        sm: 'h-7 rounded-full px-2.5 text-[10px]',
        lg: 'h-9 rounded-full px-7 text-[13px]',
        icon: 'size-8',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);
